import nokia from "../assets/images/nokia_3310.png";
import iphone from "../assets/images/iphone_4.png";
import gameboy from "../assets/images/gameboy.png";
import commodore from "../assets/images/commodore_64.png";
import kenbak from "../assets/images/kenbak_1.png";
import apolloGuidance from "../assets/images/apollo_guidance_computer.png";
import smartphone from "../assets/images/smartphone.png";
import backgroundApollo from "../assets/images/background_apollo.png";
import backgroundApolloMobile from "../assets/images/background_apollo_mobile.png";
import backgroundKenbak from "../assets/images/background_kenbak.png";
import backgroundKenbakMobile from "../assets/images/background_kenbak_mobile.png";
import backgroundCommodore from "../assets/images/background_commodore.png";
import backgroundCommodoreMobile from "../assets/images/background_commodore_mobile.png";
import backgroundGameboy from "../assets/images/background_gameboy.png";
import backgroundGameboyMobile from "../assets/images/background_gameboy_mobile.png";
import backgroundNokia from "../assets/images/background_nokia.png";
import backgroundIphone from "../assets/images/background_iphone.png";
import backgroundIphoneMobile from "../assets/images/background_iphone_mobile.png";

import fabriek from "../assets/images/fabriek.svg";
import zwembad from "../assets/images/zwembad.svg";
import huis from "../assets/images/huis.svg";
import kamer from "../assets/images/kamer.svg";
import koelkast from "../assets/images/koelkast.svg";
import koffer from "../assets/images/koffer.svg";
import achterzak from "../assets/images/achterzak.svg";

const STEPS = [
  {
    key: "60",
    deviceImage: apolloGuidance,
    volumeImage: fabriek,
    backgroundDesktop: backgroundApollo,
    backgroundMobile: backgroundApolloMobile,
    thickness: 1,
  },
  {
    key: "70",
    deviceImage: kenbak,
    volumeImage: zwembad,
    backgroundDesktop: backgroundKenbak,
    backgroundMobile: backgroundKenbakMobile,
    thickness: 10,
  },
  {
    key: "80",
    deviceImage: commodore,
    volumeImage: huis,
    backgroundDesktop: backgroundCommodore,
    backgroundMobile: backgroundCommodoreMobile,
    thickness: 50,
  },
  {
    key: "90",
    deviceImage: gameboy,
    volumeImage: kamer,
    backgroundDesktop: backgroundGameboy,
    backgroundMobile: backgroundGameboyMobile,
    thickness: 100,
  },
  {
    key: "0",
    deviceImage: nokia,
    volumeImage: koelkast,
    backgroundDesktop: backgroundNokia,
    backgroundMobile: backgroundNokia,
    thickness: 500,
  },
  {
    key: "10",
    deviceImage: iphone,
    volumeImage: koffer,
    backgroundDesktop: backgroundIphone,
    backgroundMobile: backgroundIphoneMobile,
    thickness: 1000,
  },
  {
    key: "nu",
    deviceImage: smartphone,
    volumeImage: achterzak,
    volumeSpecial: true,
    yearSpecial: true,
    backgroundDesktop: smartphone,
    backgroundMobile: smartphone,
    thickness: 10000,
  },
];

export default STEPS;
